// extracted by mini-css-extract-plugin
export default {"stockStatus":"ProductDetailInStock_stockStatus__M8nqL"};